import { IconButton, Tooltip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { b2bColors } from '../styles/b2bTheme';
import { useFavorites } from '../contexts/FavoritesContext';

/**
 * Étoile de mise en favori. La liste est partagée par compte client, d'où
 * le libellé « favoris de l'entreprise » plutôt que « mes favoris ».
 *
 * Le bouton ne se désactive pas pendant la requête : rester cliquable évite
 * le clignotement sur un double-clic, et le contexte ignore un toggle déjà
 * en vol pour le même produit.
 */
export default function FavoriteButton({ product, size = 'small' }) {
    const { isFavorite, toggle } = useFavorites();
    const active = isFavorite(product.id);
    const label = active
        ? `Retirer ${product.name} des favoris de l'entreprise`
        : `Ajouter ${product.name} aux favoris de l'entreprise`;

    return (
        <Tooltip title={active ? 'Retirer des favoris' : 'Ajouter aux favoris'}>
            <IconButton
                size={size}
                aria-label={label}
                aria-pressed={active}
                onClick={(e) => { e.stopPropagation(); toggle(product); }}
                sx={{
                    color: active ? b2bColors.accent : b2bColors.textDisabled,
                    '&:hover': { color: active ? b2bColors.accent : b2bColors.textMuted },
                }}
            >
                {active ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
            </IconButton>
        </Tooltip>
    );
}
